import { Box, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useContext, useEffect, useState } from "react";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import CommonUtil from "../../util/CommonUtils";
import { useTranslation } from "react-i18next";
import AppContext from "../../config/AppContext";

const CssTextField = styled(TextField)(({ mode }) => ({
    "& .MuiOutlinedInput-root ": {
        padding: "0px !important",
        backgroundColor: `${mode === 'light' ? "#ffff" : "#000"} !important`,
        opacity: 1,
        font: "normal normal normal 16px/20px Gotham",
        color: `${mode === 'light' ? "#242424" : "#ffffff"} !important`,

        "& input::placeholder": {
            color: mode === 'light' ? "#24242480 !important" : "#f8f8f880 !important",
            opacity: 1,
        },

        "& input:-webkit-autofill": {
            WebkitBoxShadow: `0 0 0 1000px ${mode === 'light' ? "#f4f2fe" : "#161421"} inset !important`,
            WebkitTextFillColor: `${mode === 'light' ? "#242424" : "#ffffff"} !important`,
            borderRadius: '0px',
        },
        "& input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active": {
            WebkitBoxShadow: `0 0 0 1000px ${mode === 'light' ? "#f4f2fe" : "#161421"} inset !important`,
            WebkitTextFillColor: `${mode === 'light' ? "#242424" : "#ffffff"} !important`,
        },

        "& fieldset": {
            color: `${mode === 'light' ? "#242424" : "#ffffff"} !important`,
            borderTop: "none",
            borderLeft: "none",
            borderRight: "none",
            borderBottom: "none",
        },
        "&.Mui-focused fieldset": {
            color: `${mode === 'light' ? "#242424" : "#ffffff"} !important`,
            borderTop: "none",
            borderLeft: "none",
            borderRight: "none",
            borderBottom: "none",
        },
        "&.Mui-focused ": {
            color: `${mode === 'light' ? "#242424" : "#ffffff"} !important`,
        },
    },
}));

export default function TagTextField(props) {
    const [helperText, setHelperText] = useState(props.helperText);
    const [error, setError] = useState(props.error);
    const { t } = useTranslation();
    const [isFocused, setIsFocused] = useState(false);
    const [placeholderText, setPlaceholderText] = useState(props.label);
    const { mode } = useContext(AppContext);

    useEffect(() => {
        setError(props.error);
        setHelperText(props.helperText);
    }, [props.error]);

    const handleChange = (e) => {
        let val = e.target.value;
        if (val.trim() === "") {
            val = val.trim();
        }
        if (e.target.value.length > 0 && val.length == 0) {
            return;
        }
        if (val.length > 2) {
            if (val[val.length - 1] === " " && val[val.length - 2] === " ") {
                return;
            }
            if (val[0] === " ") {
                return;
            }
        }
        if (props.validation) {
            switch (props.validation) {
                case "alpha-numeric":
                    handleAlphaNumeric(e);
                    break;
                case "numeric":
                    handleNumeric(e);
                    break;
                case "email":
                    handleEmail(e);
                    break;
                case "url":
                    handleUrl(e);
                    break;
                case "password":
                    handlePassword(e);
                    break;
                case "code":
                    handleCode(e);
                    break;
                case "mobile":
                    handleMobile(e);
                    break;
                case "postcode":
                    handlePostCode(e);
                    break;
                case "alpha-numeric-underscore":
                    handleCodeUnderscore(e);
                    break;
                case "alpha-numeric-space":
                    handleAlphaNumericSpace(e);
                    break;
                case "numericWithoutDot":
                    handleNumericWithoutDot(e);
                    break;
                default:
                    props.onChange(e);
            }
        } else {
            props.onChange(e);
        }
    };

    const handleAlphaNumeric = (e) => {
        if (CommonUtil.isAlphaNumericSpace(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0025"));
        }
    };

    const handleCodeUnderscore = (e) => {
        if (CommonUtil.isAlphaNumericUnderscore(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("Only accepts alphabets, numerics and underscore"));
        }
    };

    const handleAlphaNumericSpace = (e) => {
        if (CommonUtil.isAlphaNumericSpace(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(
                t("Only accepts alphabets, numerics, space and underscore")
            );
        }
    };
    const handleNumericWithoutDot = (e) => {
        if (CommonUtil.isValidPasitiveNumeric(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText("Only accepts numerics");
        }
    };

    const handleCode = (e) => {
        if (CommonUtil.isAlphaNumeric(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0023"));
        }
    };

    const handlePostCode = (e) => {
        if (CommonUtil.isValidCode(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0021"));
        }
    };

    const handleNumeric = (e) => {
        if (CommonUtil.isValidNumeric(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0024"));
        }
    };

    const handleEmail = (e) => {
        props.onChange(e);
        if (CommonUtil.isValidEmail(e.target.value)) {
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0022"));
        }
    };

    const handleUrl = (e) => {
        props.onChange(e);
        if (CommonUtil.isValidUrl(e.target.value)) {
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0029"));
        }
    };

    const handleMobile = (e) => {
        if (CommonUtil.isValidPasitiveNumeric(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0024"));
        }
    };

    const handlePassword = (e) => {
        props.onChange(e);
        if (CommonUtil.isAlphaNumericPassword(e.target.value)) {
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0010"));
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
        if (props.label && !props.label?.includes("Search") && !props.label?.includes("Enter")) {
            setPlaceholderText(`${t("RAL0089")}${props.label.toLowerCase()}`);
        }
    };

    const handleBlur = () => {
        setIsFocused(false);
        setPlaceholderText(props.label);
    };

    return (
        <Box width={"100%"}>
            <CssTextField
                mode={mode}
                className={`tag-input1 ${mode === 'dark' ? "tag-input_dark1" : ""}`}
                {...props}
                id={props.id}
                name={props.name}
                error={error}
                placeholder={isFocused ? placeholderText : props.label}
                onFocus={handleFocus}
                onBlur={handleBlur}
                label=""
                fullWidth
                helperText={""}
                autoComplete="new-password"
                value={props.value}
                onChange={(e) => handleChange(e)}
            />
        </Box>
    );
}
